import {StyleSheet, View} from 'react-native';
import React, {PropsWithChildren} from 'react';
import {NativeStackScreenProps} from '@react-navigation/native-stack';
import {RootNavigatorParams} from 'navigation/Routes';
import {Sidebar} from 'components/common';
import {colors} from 'theme/Colors';
import {corner_radius, spacing} from 'theme/Units';
import {projectName } from 'redux/selectors/projectSelector';
import {useSelector} from 'react-redux';
import Breadcrumbs from '../BreadCrumbs';

export const ProjectDashbordLayout: React.FC<
  PropsWithChildren<NativeStackScreenProps<RootNavigatorParams>>
> = props => {
  const {children} = props;
  const currentProjectName = useSelector(projectName);


  return (
    <View style={styles.container}>
      <View style={styles.header}>
        <Breadcrumbs projectName={currentProjectName || ''}/>
      </View>
      <View style={styles.secondaryContainer}>
        <Sidebar />
        <View style={styles.content}>{children}</View>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: colors.palette.white,
  },
  header: {
    height: 60,
    paddingHorizontal: 32,
    justifyContent: 'center',
    shadowColor: 'rgba(0, 0, 0, 0.15)',
    shadowOffset: {width: 0, height: 2},
    shadowRadius: 4,
  },
  headingText: {
    color: colors.palette.brandBlue,
    fontWeight: 600,
    fontSize: 32,
  },
  secondaryContainer: {
    flexDirection: 'row',
    padding: spacing['4'],
    gap: spacing['4'],
    flex: 1,
  },
  content: {
    flex: 1,
    backgroundColor: colors.palette.white,
    borderColor: colors.palette.stroke,
    borderWidth: 1,
    borderRadius: corner_radius['rounded-md'],
  },
});
